import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-menu",
  "use": "icon-menu-usage",
  "viewBox": "0 0 22 15",
  "content": "<symbol viewBox=\"0 0 22 15\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-menu\">\n    <rect width=\"22\" height=\"3\" rx=\"1.5\" />\n    <rect y=\"6\" width=\"22\" height=\"3\" rx=\"1.5\" />\n    <rect y=\"12\" width=\"22\" height=\"3\" rx=\"1.5\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol